import {getLang, setLang} from '@/js/lang/lang'
import * as glbData from '@/js/globalData'
import * as tokenPrc from '@/js/tokenProcess'
import {systemSettingAPI} from '@/api/restfulAPI'
import store from '@/store'

const Main = () => import(/* webpackChunkName: "g-main" */ '@/components/Main')
const OrgList = () => import(/* webpackChunkName: "g-groupmanage" */ '@/components/orgList/OrgList')
const UserManagement = () => import(/* webpackChunkName: "g-groupmanage" */ '@/components/userManagement/UserManagement')
const SketchBoard = () => import(/* webpackChunkName: "g-groupmanage" */ '@/components/sketchBoard/SketchBoard')
const DataSource = () => import(/* webpackChunkName: "g-groupmanage" */ '@/components/dataSource/DataSource')
const Menu = () => import(/* webpackChunkName: "g-groupmanage" */ '@/components/menu/Menu')
const OrgSetting = () => import(/* webpackChunkName: "g-groupmanage" */ '@/components/orgSetting/OrgSetting')
const User = () => import(/* webpackChunkName: "g-groupmanage" */ '@/components/user/User')
const SystemSetting = () => import(/* webpackChunkName: "g-groupmanage" */ '@/components/systemSetting/SystemSetting')
const UserProfile = () => import(/* webpackChunkName: "g-groupmanage" */ '@/components/userProfile/UserProfile')
const Login = () => import(/* webpackChunkName: "g-login" */ '@/components/login/Login')
const LoginNew = () => import(/* webpackChunkName: "g-login" */ '@/components/login/login_new')
const ForgetPassword = () => import(/* webpackChunkName: "g-login" */ '@/components/login/ForgetPassword')
const VersionInfo = () => import(/* webpackChunkName: "g-groupmanage" */ '@/components/systemSetting/Version')
const Error = () => import(/* webpackChunkName: "g-error" */ '@/components/error/Error')

// let NVG_LANG = nvgLang
// let NVG_LANG = getLang()

const forgetPassword = {
  path: 'forgetPassword',
  name: glbData.FORGETPASSWORD_CMPN,
  component: ForgetPassword
}
const orgListRoutes = {
  path: glbData.PATH_ORG_LIST,
  name: glbData.ORG_LIST,
  component: OrgList
}
const userManagementRoutes = {
  path: glbData.PATH_USER_MANAGEMENT,
  name: glbData.USER_MANAGEMENT,
  component: UserManagement
}
const sketchBoardRoutes = {
  path: glbData.PATH_SKETCH_BOARD + '/:orgId',
  name: glbData.SKETCH_BOARD,
  component: SketchBoard
}
const dataSourceRoutes = {
  path: glbData.PATH_DATA_SOURCE + '/:orgId',
  name: glbData.DATA_SOURCE,
  component: DataSource
}
const menuRoutes = {
  path: glbData.PATH_MENU + '/:orgId',
  name: glbData.MENU,
  component: Menu
}
const orgSettingRoutes = {
  path: glbData.PATH_ORGSETTING + '/:orgId',
  name: glbData.ORGSETTING,
  component: OrgSetting
}
const userRoutes = {
  path: glbData.PATH_USER + '/:orgId',
  name: glbData.USER,
  component: User
}
const systemSettingRoutes = {
  path: glbData.PATH_SYSTEM_SETTING,
  name: glbData.SYSTEM_SETTING,
  component: SystemSetting
}
const userProfileRoutes = {
  path: glbData.PATH_USER_PROFILE,
  name: glbData.USER_PROFILE,
  component: UserProfile
}
const versionInfoRoutes = {
  path: glbData.PATH_VERSION_INFORMATION,
  name: glbData.VERSION_INFORMATION,
  component: VersionInfo
}

const mainRoutes = {
  path: ':lang?/main',
  name: glbData.MAIN_CMPN,
  component: Main,
  props: (route) => {
    const localLANG = getLang()
    return {
      lang: route.params.lang ? route.params.lang : localLANG
    }
  },
  beforeEnter (to, from, next) {
    systemSettingAPI.getSystemSetting().then(resp => {
      if (resp.errCode === 0) {
        let systemInfo = resp.data
        systemInfo.location = resp.data["local_sign_in"] ? 'local' : 'cloud'
        systemInfo.sketch3D = resp.data["sketchboard_3D"]
        systemInfo.builtin = resp.data["built_in"]
        systemInfo.hideUserMgr = resp.data["hide_user_mgr"]
        systemInfo.logoutAddr = resp.data["logout_addr"]
        systemInfo.nodeRedEnable = resp.data["node_red"]
        systemInfo.nodeRedUrl = resp.data["node_red_uris"]
        systemInfo.dataSourceImport = resp.data["data_source_import"]
        systemInfo.edition = resp.data["edition"]
        store.commit("setSystemInfo", systemInfo)
      }
      next()
    }).catch(() => {
      next()
      console.log('getSystemInfo error')
    })
  },
  // redirect: {name: glbData.DEVICE_MANAGE},
  redirect: () => {
    const localLANG = getLang()
    return {name: glbData.ORG_LIST, params: {lang: localLANG}}
  },
  children: [
    orgListRoutes,
    userManagementRoutes,
    sketchBoardRoutes,
    dataSourceRoutes,
    menuRoutes,
    orgSettingRoutes,
    userRoutes,
    systemSettingRoutes,
    userProfileRoutes,
    versionInfoRoutes
  ]
}

const loginRoutes = {
  path: ':lang?/login',
  name: glbData.LOGIN_CMPN,
  component: Login,
  props: (route) => {
    const localLANG = getLang()
    return {
      lang: route.params.lang !== undefined ? route.params.lang : localLANG
    }
  },
  beforeEnter: (to, from, next) => {
    systemSettingAPI.getSystemSetting().then(resp => {
      if (resp.errCode === 0) {
        if (resp.data["logout_addr"] !== '/') {
          window.location.href = resp.data["logout_addr"]
        } else {
          next()
        }
      }
    }).catch(() => {
      console.log('getUser error')
    })
  }
}

const errorRoutes = {
  path: 'error/:type?',
  name: 'error',
  component: Error
}

const loginNew = {
  path: glbData.PATH_LOGIN_NEW_CMPN,
  name: glbData.LOGIN_NEW_CMPN,
  component: LoginNew,
  props: (route) => {
    const localLANG = getLang()
    return {
      lang: route.params.lang !== undefined ? route.params.lang : localLANG
    }
  },
  beforeEnter: (to, from, next) => {
    systemSettingAPI.getSystemSetting().then(resp => {
      if (resp.errCode === 0) {
        if (resp.data["logout_addr"] !== '/') {
          window.location.href = resp.data["logout_addr"]
        } else {
          next()
        }
      }
    }).catch(() => {
      console.log('getUser error')
    })
  }
}

export const routes = [
  {
    path: '/',
    component: {
      template: '<router-view></router-view>'
    },
    beforeEnter (to, from, next) {
      // console.log('first', from, to.name, to.params)
      next()
    },
    redirect: () => {
      const localLANG = getLang()
      return {name: glbData.MAIN_CMPN, params: {lang: localLANG}}
    },
    children: [
      loginRoutes,
      errorRoutes,
      forgetPassword,
      loginNew,
      mainRoutes
    ]
  }
]

// function checkRouteRole (routeName) {
//   let bRet = true
//   let moduleName = glbData.getModuleName(routeName)
//   if (moduleName === glbData.SYS_CONFIG_CMPN ||
//     moduleName === glbData.USER_CONFIG_CMPN) bRet = false
//   return bRet
// }

export function routeInterupter (to, from, next) {
  // let curLang = to.params.lang === undefined ? NVG_LANG : to.params.lang
  // next({name: glbData.ORG_LIST, params: {lang: curLang}})
  // next()
  // store.dispatch('productInfo/getProductConfig', to.params.orgId)
  // console.log(`---routeInterupter---: name: ${to.name}, ordId: ${to.params.orgId}`)
  const toName = to.name;
  if (toName === glbData.SKETCH_BOARD ||
    toName === glbData.DATA_SOURCE ||
    toName === glbData.MENU ||
    toName === glbData.ORGSETTING ||
    toName === glbData.USER) {
    store.dispatch('productInfo/getProductConfig', to.params.orgId)
  } else {
    store.dispatch('productInfo/getProductConfig')
  }
  // let curLang = to.params.lang === undefined ? NVG_LANG : to.params.lang
  // curLang = (curLang !== NVG_LANG) ? NVG_LANG : curLang
  let curLang = getLang()
  if (to.params.lang !== curLang) {
    curLang = to.params.lang
    setLang(to.params.lang)
  }
  let EIName = tokenPrc.getCookie('EIName')
  if (EIName === undefined || EIName === '') {
    console.log('not login success', to.name, to.path)
    if (to.name === glbData.FORGETPASSWORD_CMPN || to.name === 'error' || to.name === null) {
      next()
    } else if (to.name === glbData.LOGIN_CMPN) {
      next()
    } else if (to.name === glbData.LOGIN_NEW_CMPN) {
      next()
    } else {
      // next({name: glbData.LOGIN_CMPN, params: {lang: curLang}})
      next({name: glbData.LOGIN_NEW_CMPN, params: {lang: curLang}})
    }
  } else {
    // console.log('login success')
    next()
  }
  // let curLang = to.params.lang === undefined ? NVG_LANG : to.params.lang
  // let exp = tokenPrc.getExpFromToken()
  // if (exp != null) {
  //   let nowTs = new Date().getTime() / 1000
  //   if (to.name === glbData.LOGIN_CMPN || to.name === glbData.FORGETPASSWORD_CMPN || to.name === null) {
  //     if (exp - nowTs > 0) {
  //       next({name: glbData.MAIN_CMPN, params: {lang: curLang}})
  //     } else {
  //       next()
  //       // next({name: glbData.LOGIN_CMPN, params: {lang: curLang}})
  //     }
  //   } else {
  //     // console.log(exp + ' ' + nowTs)
  //     if (exp - nowTs > 0) {
  //       next()
  //     } else {
  //       next({name: glbData.LOGIN_CMPN, params: {lang: curLang}})
  //     }
  //   }
  // } else {
  //   if (to.name !== glbData.LOGIN_CMPN && to.name !== glbData.FORGETPASSWORD_CMPN) {
  //     next({name: glbData.LOGIN_CMPN, params: {lang: curLang}})
  //   } else {
  //     next()
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/router/routes.js